import React from 'react';
import './gallery.css';
import g1 from "../assets/g1.jpeg";
import g2 from "../assets/g2.jpeg";
import g3 from "../assets/g3.jpeg";
import g4 from "../assets/g4.jpeg";
import g5 from "../assets/g5.jpeg";
import g6 from '../assets/g6.jpeg';
import g7 from "../assets/g7.jpeg";
import im from '../assets/im.png';
import im2 from '../assets/im2.png';
import im3 from '../assets/im3.png';
import im4 from '../assets/im4.png';
import im5 from '../assets/im5.png';
import im6 from '../assets/im6.png';
import im7 from '../assets/im7.png'; 
import writer from "../assets/writer.jpeg";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Nav from './Nav';
import { FaCamera, FaAward, FaMusic } from "react-icons/fa";

const scrollImages = [
  g1, g2, g3, im, im2, im3, im4 
];

const gridImages = [
  g4, g5, g6, g7, writer,im5, im6, im7];

const Gallery = () => {
  return (
    <>
      <Nav/>
      <Navbar/>

      {/* Redesigned Gallery Hero Section */}
      <section className="gallery-hero-banner">
        <div className="gallery-hero-overlay">
          <div className="gallery-hero-container">
            <h1 className="hero-title">Glimpses of Musical Heritage</h1>
            <p className="hero-subtitle">
              A curated photographic retrospective celebrating timeless sitar performances, historic masterclasses, national felicitations, and the vibrant lineage of Indian Classical Music.
            </p>
            <div className="hero-features-strip">
              <div className="hero-feature-item">
                <FaCamera className="feat-icon" />
                <span>Archival Performance Photos</span>
              </div>
              <div className="hero-feature-item">
                <FaAward className="feat-icon" />
                <span>National Honors &amp; Awards</span>
              </div>
              <div className="hero-feature-item">
                <FaMusic className="feat-icon" />
                <span>University Seminars &amp; Disciples</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="gallery-section">


      {/* Infinite horizontal scroll section */}
      <div className="horizontal-scroll">
        <div className="scroll-wrapper">
          {[...scrollImages, ...scrollImages].map((img, index) => (
            <div className="scroll-item" key={index}>
              <img src={img} alt={`scroll-img-${index}`} />
            </div>
          ))}
        </div>
      </div>

      {/* Masonry gallery section */}
      <div className="gallery-masonry">
        {gridImages.map((img, index) => (
          <div className="gallery-box" key={index} style={{ "--i": index + 1 }}>
            <img src={img} alt={`gallery-${index}`} />
          </div>
        ))}
      </div>
    </section>
    <Footer/>
    </>
  );
};

export default Gallery;